module.exports = __webpack_public_path__ + "static/media/embedded1.3b5ab6c1.jpg";